import LoopWinsMediator from "slotworks/mediators/loop-wins-mediator";
import State from "slotworks/state-machine/states/state";
import {IdleSymbolsCommand} from "../../../commands/symbols/idle-symbols-command";

export default class LoopWins extends State {

    private loopWinsMediator: LoopWinsMediator;

    public onEnter() {
        this.loopWinsMediator = new LoopWinsMediator();

        this.loopWinsMediator.start().then(() => this.complete());
    }

    public onSkip() {
        this.loopWinsMediator.end().then(() => this.skip());
    }

    public onExit() {
        IdleSymbolsCommand().execute();
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/state-machine/standard/states/loop-wins.ts